import { MODERATOR, PLATFORM_OWNER, CMNTY, PARTICIPANT } from '../../../User/Roles';

export default ({ user }) => [MODERATOR, PLATFORM_OWNER, CMNTY, PARTICIPANT].includes(user.role.type);
